//js
import '../src/assets/js/yandex-captcha.js';
